import type { ConceptDef } from '../types';

export const pictureSentenceBeach: ConceptDef = {
  kind: 'pictureSentence',
  id: 'picture-sentence-beach',
  label: 'Build a Sentence: The Beach',
  category: 'Literacy',
  description: 'Look at a picture of a beach; drag the mixed-up words into a sentence about it.',
  config: {
    picture: '/library/beach-swing.jpg',
    sentences: [
      'A wooden swing hangs from the tree.',
      'A white boat floats on the blue sea.',
      'The sand on the beach is soft and yellow.',
      'Green leaves grow on the big tree.',
      'The swing is in the shade.',
      'White clouds are in the blue sky.',
    ],
  },
};
